module.exports = __webpack_public_path__ + "img/summary-total-dex.9ea09f86.svg";